export default '/pro';
